import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { AppState } from '@zerops/zerops/app';
import { validate, FormState } from 'ngrx-forms';
import { required, email } from 'ngrx-forms/validation';
import { FEATURE_NAME } from './account-form.constant';

export interface AccountFormValue {
  firstName: string;
  lastName: string;
  email: string;
}

export type AccountFormState = FormState<AccountFormValue>;

@Injectable({ providedIn: 'root' })
export class AccountForm extends ZefForm<AccountFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        firstName: '',
        lastName: '',
        email: ''
      },
      {
        firstName: validate(required),
        email: validate(email)
      }
    );
  }
}
